import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/SectionReveal";
import { CITIES } from "@/data/site";

export default function ServiceAreas() {
  return (
    <section id="areas" className="py-24 sm:py-32 bg-gradient-to-b from-sky-50/40 to-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal className="max-w-3xl">
          <p className="text-xs tracking-[0.22em] uppercase font-bold text-sky-700">Service Areas</p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Proudly serving Tampa Bay.
          </h2>
          <p className="mt-4 text-slate-600">
            Local pool cleaning, maintenance, and 24/7 emergency service across these communities. Click your
            city for details.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {CITIES.map((c, i) => (
            <Reveal
              key={c.slug}
              direction={i % 3 === 0 ? "left" : i % 3 === 1 ? "up" : "right"}
              delay={i * 0.03}
              testId={`area-card-${c.slug}`}
              className="group rounded-3xl bg-white border border-slate-100 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_40px_rgba(10,37,64,0.12)] transition-all hover:-translate-y-1"
            >
              <Link
                to={`/service-areas/${c.slug}`}
                className="flex h-full p-6 gap-4 items-start"
                data-testid={`area-link-${c.slug}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-sky-50 text-sky-700 inline-flex items-center justify-center">
                  <MapPin className="w-5 h-5" />
                </div>
                <div className="flex-1">
                  <p className="font-heading font-bold text-slate-900 text-lg flex items-center gap-1">
                    {c.name}, FL
                    <ArrowUpRight className="w-4 h-4 text-sky-700 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" />
                  </p>
                  <p className="mt-1 text-sm text-slate-600 leading-relaxed">{c.blurb}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
